import { pdf } from '@react-pdf/renderer';
import { createElement } from 'react';

import { ESignPDFTemplate } from './pdf-template';

export const renderPDF = async (props) => {
  const data = { totalPages: 0, blob: null };

  const pdfDocument = pdf(
    createElement(
      ESignPDFTemplate, {
        form: props,
        onRender: ({ totalPages }) => {
          data.totalPages = totalPages
        }
      }
    )
  );
  
  data.blob = await pdfDocument.toBlob();

  return data;
};